import styled from 'styled-components';

export const ErrorContainer = styled.div`
  color: var(--negative-color);
  font-size: 1rem;
  padding: 5px 17px;
`;
